import { SelectableBillingPeriodTypes } from '@constants/billingPeriods'
import { CurrencyType } from '@constants/currencies'
import { PlanRecordKeyTypes } from '@constants/plans'
import { useGetPlanAddons } from '@pages/Checkout/hooks/useGetPlanAddons'
import { Icon, Image, Paragraph, Spacer, Spreader, Tooltip } from '@ui-kit'
import { FC, Fragment } from 'react'
import { Trans } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'
import { v4 as uuidv4 } from 'uuid'

interface FeaturesProps {
  recordKey: PlanRecordKeyTypes
  currency: CurrencyType
  billingPeriod: SelectableBillingPeriodTypes
}

export const Addons: FC<FeaturesProps> = ({
  recordKey,
  currency,
  billingPeriod
}) => {
  const { availableAddonsForPlan, totalPrice } = useGetPlanAddons({
    recordKey,
    currency,
    billingPeriod
  })

  return (
    <Column>
      {totalPrice ? (
        <Paragraph color='neutral-6'>
          <Trans
            i18nKey='checkout.plans.plan.addons.sum.price'
            values={{
              price: totalPrice,
              currency
            }}
          />
        </Paragraph>
      ) : null}

      <Spacer space={5} />

      {availableAddonsForPlan.map(({ icon, name, tooltip }) => (
        <Fragment key={uuidv4()}>
          <Tooltip content={tooltip} placement='top'>
            <Row>
              <Image src={icon} width='18px' height='18px' />

              <Spreader spread={10} />

              <Row vertical='baseline'>
                <Paragraph lineHeight='normal'>{name}</Paragraph>

                <Spreader spread={5} />

                <Icon icon='icon-help_outline' size={12} color='neutral-4' />
              </Row>
            </Row>
          </Tooltip>

          <Spacer space={10} />
        </Fragment>
      ))}
    </Column>
  )
}

Addons.displayName = 'CheckoutPlansPlanPanelsPlanAddons'
